var MultipleGuestServiceProviderModel = require('../../../app/models/multiple-guest/multiple-guest');
const { checkinLaterState } = require("../../../shared/managers/checkin-later-manager");

var MapSelectorModel = Backbone.Epoxy.Model.extend({

  defaults: {
    showStoreModal: false,
    storeName: '',
    storeAddressLine1: '',
    storeAddressLine2: '',
    storeEmail: '',
    storePhone: '',
    storeRating: 0,
    storeReviewsCount: 0,

    hasAvailability: false,
    statusTitle: 'Open',
    statusMessage: '',
    statusClass: '',
    schedule: null,
    nextDaySchedule: null,
    currentTime: null,

    estimatedTime: 0,
    service: null,
    provider: null,

    informationIsValid: false,
    alreadyInQueue: false,
    isSubmitting: false,
    isFullyLoaded: true,

    iAmOnlyCheckingInAGuest: false,

    guests: new MultipleGuestServiceProviderModel(),

    availableSlots: [],
    useCheckinLater: false,
    guestsHash: '',
  },

  computeds: {
    estimatedTimeString: function() {
      var time = bookedby.helpers.secondsToMinutesRoundable(this.get('estimatedTime'), 1);
      return time + ' min.'
    },
    estimatedTimeMin: function() {
      return bookedby.helpers.secondsToMinutesRoundable(this.get('estimatedTime'), 1);
    },
    storeIsUnavailable: function () {
      return this.get('statusClass') == 'unavailable';
    },
    storeIsClosed: function() {
      return this.get('statusClass') == 'closed';
    },
    canAddMoreGuests: function() {
      return this.get('guests').get('numberOfGuests') < (bookedby.staticData.storeGroupSettings.maxNumberOfGuests - 1);
    },
    overWaitTimeShown: function() {
      return this.get('guests').get('overWaitTimeShown')
    },
    storeGmapsDirections: {
      deps:['storeAddressLine1', 'storeAddressLine2'],
      get: function(storeAddressLine1, storeAddressLine2) {
        var params = $.param({ daddr: storeAddressLine1 + ' ' + storeAddressLine2 });
        return "https://maps.google.com?" + params;
      }
    },
    storeHasEmail: {
      deps:['storeEmail'],
      get: function(storeEmail) {
        return !_.isEmpty(storeEmail);
      }
    },
    storeHasPhone: {
      deps:['storePhone'],
      get: function(storePhone) {
        return !_.isEmpty(storePhone);
      }
    },
    storeHasSchedule: {
      deps: ['schedule'],
      get: function(schedule) {
        return schedule && (schedule.from && schedule.to);
      }
    },
    storeSchedule: {
      deps: ['schedule'],
      get: function(schedule) {
        if (!schedule || !schedule.from || !schedule.to)
          return 'Closed';

        return 'Open today from ' + bookedby.helpers.timeFormat(schedule.from) + ' until ' +  bookedby.helpers.timeFormat(schedule.to);
      }
    },
    beforeSchedule: {
      deps: ['schedule', 'currentTime'],
      get: function(schedule, currentTime) {
        return schedule && (currentTime || currentTime === 0) && schedule.from > currentTime;
      }
    },
    afterSchedule: {
      deps: ['schedule', 'currentTime', 'nextDaySchedule'],
      get: function(schedule, currentTime, nextDaySchedule) {
        return schedule && (currentTime || currentTime === 0) &&
          schedule.to && schedule.from &&
          schedule.to <= currentTime && nextDaySchedule &&
          nextDaySchedule.from && nextDaySchedule.to;
      }
    },
    notAvailableForToday: {
      get: function() {
        return this.get('statusClass') === 'not-available-for-today'
      }
    },
    opensTime: {
      deps: ['schedule'],
      get: function (schedule) {
        if (!schedule) return '';
        return bookedby.helpers.timeFormatMarker(schedule.from);
      }
    },

    opensNextDayTime: {
      deps: ['nextDaySchedule'],
      get: function (nextDaySchedule) {
        if (!nextDaySchedule) return '';
        return bookedby.helpers.timeFormatMarker(nextDaySchedule.from);
      }
    },

    closesTime: {
      deps: ['schedule'],
      get: function (schedule) {
        if (!schedule) return '';
        return bookedby.helpers.timeFormatMarker(schedule.to);
      }
    },

    overWaitTime: {
      deps: ['estimatedTime'],
      get: function(estimatedTime) {
        return estimatedTime >= bookedby.staticData.storeGroupSettings.capWaitTimesAfter
      }

    },

    hasAvailableSlots: {
      deps: ['availableSlots'],
      get: function(availableSlots) {
        return availableSlots.length > 0
      }
    },

    isAllEmployeesFA: {
      deps: ['provider', 'guestsHash'],
      get: function (provider, guests) {
        if (provider !== null) {
          return false;
        }

        return !this.get('guests').get('serviceProviders').some(function(guest) {
          return guest.get('provider') !== null;
        });
      }
    },

    isEmployeeFA: {
      deps: ['provider'],
      get: function (provider) {
        return provider === null
      }
    },

    useCheckinLater: {
      deps: ['storeName'],
      get: function() {
        return checkinLaterState.getUseCheckinLater();
      }
    },
  }

});

module.exports = MapSelectorModel;
